import { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  Box,
  Button,
} from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import DateRangeIcon from "@mui/icons-material/DateRange";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import QRCode from "react-qr-code";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import { format } from "date-fns";
import { es } from "date-fns/locale";

import { getUserTickets } from "../../api/providers/userDataProviders";
import { AccountLayout } from "../../layouts";

type Ticket = {
  id: number;
  purchaseDate: string;
  buyerInfo: string;
  event: {
    id: number;
    name: string;
    startDate: string;
    address: string;
  };
  organization: {
    id: number;
    name: string;
  };
  ticketHolder: string;
  ticketRole: string;
  ticketVariant: {
    id: number;
    name: string;
  };
};

export const UserTickets = () => {
  const [tickets, setTickets] = useState<Ticket[]>([]);

  useEffect(() => {
    userTickets();
  }, []);

  const userTickets = async () => {
    try {
      const result = await getUserTickets();
      if (result.ok) {
        setTickets(result.data.tickets);
      }
    } catch (error) {
      console.error("Error obteniendo los datos del usuario:", error);
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return format(date, "EEEE, d 'de' MMMM", { locale: es });
  };

  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    return format(date, "h:mm a");
  };

  return (
    <AccountLayout>
      <Container>
        <Grid container spacing={6} mt={"10%"} mb={"10%"} justifyContent={"center"}>
          <Grid item xs={12}>
            <Typography
              variant="h4"
              align="left"
              sx={{ color: "text.primary", fontWeight: "normal" }}
            >
              Mis tickets
            </Typography>
          </Grid>
          {tickets?.map((ticket: Ticket) => (
            <Grid item xs={12} sm={6} md={6} key={ticket.id}>
              <Card sx={{ display: "flex", alignItems: "stretch", borderRadius: 4 }}>
                <CardContent sx={{ flex: 1, position: "relative" }}>
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{ fontWeight: "bold" }}
                    mt={1}
                    ml={2}
                  >
                    {ticket.event.name}
                  </Typography>
                  <Typography variant="body2" color="white" mt={2} ml={2}>
                    Comprado por {ticket.buyerInfo} el{" "}
                    {new Date(ticket.purchaseDate).toLocaleDateString()}
                  </Typography>
                  <Box display="flex" alignItems="center" mt={2} ml={2}>
                    <PersonOutlineIcon sx={{ mr: 1, color: "white" }} />
                    <Typography variant="body2" color="white">
                      {ticket.ticketHolder}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" mt={2} ml={2}>
                    <DateRangeIcon sx={{ mr: 1, color: "white" }} />
                    <Typography variant="body2" color="white">
                      {formatDate(ticket.event.startDate)}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" mt={2} ml={2}>
                    <AccessTimeIcon sx={{ mr: 1, color: "white" }} />
                    <Typography variant="body2" color="white">
                      {formatTime(ticket.event.startDate)}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" mt={2} ml={2}>
                    <LocationOnIcon sx={{ mr: 1, color: "white" }} />
                    <Typography variant="body2" color="white">
                      {ticket.event.address}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      bottom: 0,
                      width: "1px",
                      borderRight: "1px dashed white",
                    }}
                  />
                </CardContent>

                <Box
                  sx={{
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <QRCode value="prueba" size={150} />
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ mt: 2, mb: 1 }}
                  >
                    EDITAR TITULAR
                  </Button>
                  <Button variant="text" color="secondary">
                    Reenviar ticket
                  </Button>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </AccountLayout>
  );
};
